import React from "react"

import { sFooter } from "../styled/footer"
import { sLayout } from "../styled/layout"
import facebook from "../assets/images/facebook.svg"
import instagram from "../assets/images/instagram.svg"

import useSiteMetadata from "../hooks/use-site-metadata"

const Footer = () => {
  const { footerUrls, baseSite, social, shortTitle } = useSiteMetadata()
  return (
    <sFooter.Wrapper>
      <sLayout.Container>
        {footerUrls ? (
          <div>
            <sFooter.Links>
              {footerUrls.map(footerUrl => (
                <a href={footerUrl.url} target="_blank" rel="noopener noreferrer" key={footerUrl.title}>
                  {footerUrl.title}
                </a>
              ))}
            </sFooter.Links>
            <sFooter.Copy>{`©${new Date().getFullYear()} ${baseSite.title || shortTitle}`}</sFooter.Copy>
          </div>
        ) : null}
        <div>
          <sFooter.Social>
            {social.facebook ? (
              <a
                href={`https://www.facebook.com/${social.facebook}`}
                target="_blank"
                rel="noopener noreferrer"
                title="Facebook"
              >
                <span className="visuallyhidden">Facebook</span>
                <img src={facebook} alt="Facebook" width="19" height="19" />
              </a>
            ) : null}
            {social.instagram ? (
              <a
                href={`https://www.instagram.com/${social.instagram}/`}
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
              >
                <span className="visuallyhidden">Instagram</span>
                <img src={instagram} alt="Instagram" width="22" height="22" />
              </a>
            ) : null}
          </sFooter.Social>
        </div>
      </sLayout.Container>
    </sFooter.Wrapper>
  )
}

export default Footer
